import { Link } from "react-router-dom";
import React from "react";
import HydrationSafeSlider from "../../components/HydrationSafeSlider";

const defaultSliderSettings = {
  dots: true,
  arrows: false,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 4000,
  speed: 4000,
  cssEase: "ease",
  slidesToShow: 4,
  centerMode: true,
  centerPadding: "0px",
  slidesToScroll: 1,
  responsive: [
    { breakpoint: 1050, settings: { slidesToShow: 3 } },
    { breakpoint: 991, settings: { slidesToShow: 3 } },
    { breakpoint: 768, settings: { slidesToShow: 1 } },
    { breakpoint: 600, settings: { slidesToShow: 1 } },
  ],
};

export default function HomeIndustries({ data, sectionClass }) {
  const { title, subtitle, items } = data;

  return (
    <section className={`home-industries ${sectionClass || ""}`}>
      <div className="container">
        {/* Heading Section */}
        {(title || subtitle) && (
          <div className="row justify-content-center">
            <div className="col-md-12 col-lg-9">
              <div className="industries-text heading-gap">
                {subtitle && <span className="subtitle heading-center">{subtitle}</span>}
                {title && <h3 className="heading heading-center">{title}</h3>}
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Slider Section */}
      <div className="container">
        <div className="slider-container">
          <HydrationSafeSlider {...defaultSliderSettings} className="industries-slider">
            {items.map((item, index) => (
              <div className="industries-col" key={index}>
                <div className="industries-col-inner">
                  <div className="industries-heading">{item.title}</div>
                  <p>{item.desc}</p>
                  <div className="industries-images">
                    <img src={item.img} alt={item.title} className="img-responsive"  loading="lazy"/>
                  </div>
                  <div className="industries-btn">
                    <Link to={item.link1} className="theme-btn">  <span>{item.btn1} </span>  </Link>
                    <Link to={item.link2} className="theme-btn transparent-btn"> {item.btn2} </Link>
                  </div>
                </div>
              </div>
            ))}
          </HydrationSafeSlider>
        </div>
      </div>
    </section>
  );
}
